import api from 'services/api'

export const VIATOR_GENERIC_AFFILIATE_URL =
  'https://www.viator.com/pt-BR/?pid=P00037907&mcid=42383&medium=link&campaign=Geral'

export const getViatorAffiliateUrl = (cityName = '') => {
  const baseURL = String(api.defaults.baseURL || '').replace(/\/$/, '')
  const params = new URLSearchParams({ city: cityName })

  return `${baseURL}/viator/go?${params.toString()}`
}
